/*
 * Copyright (c) 2022 E-WIND - Thais Watanabe.
 * All rights reserved.
 */
import React from "react";

/**
 * The InspectionTypeBadge component
 *
 * @author Thais Watanabe
 */
const InspectionTypeBadge = (props) => {
  const inspectionType = props.type;

  var badgeClassName = "";
  if (inspectionType === "半年定期点検") {
    badgeClassName = "bg-blue-100 text-blue-800";
  } else if (inspectionType === "1年定期点検") {
    badgeClassName = "bg-yellow-100 text-yellow-800";
  } else {
    badgeClassName = "bg-pink-100 text-pink-800";
  }

  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${badgeClassName}`}
    >
      {inspectionType}
    </span>
  );
};

export default InspectionTypeBadge;
